import type { ComponentType } from 'react';
import { haptic } from '../telegram';
import { HistoryIcon, HomeIcon, ProfileIcon, Sparkle, TwinIcon } from './icons';

export type Tab = 'main' | 'twin' | 'create' | 'history' | 'profile';

const SIDE: { id: Exclude<Tab, 'create'>; label: string; Icon: ComponentType }[] = [
  { id: 'main', label: 'Главная', Icon: HomeIcon },
  { id: 'twin', label: 'Двойник', Icon: TwinIcon },
  { id: 'history', label: 'История', Icon: HistoryIcon },
  { id: 'profile', label: 'Профиль', Icon: ProfileIcon },
];

/** Плавающий стеклянный таббар: Главная · Двойник · ✦ · История · Профиль. */
export function TabBar({ active, onChange }: { active: Tab; onChange: (tab: Tab) => void }) {
  const go = (tab: Tab) => {
    if (tab !== active) haptic('select');
    onChange(tab);
  };
  const item = ({ id, label, Icon }: (typeof SIDE)[number]) => (
    <button
      key={id}
      type="button"
      className="tabbar__item"
      aria-current={active === id ? 'page' : undefined}
      onClick={() => go(id)}
    >
      <Icon />
      {label}
    </button>
  );

  return (
    <nav className="tabbar" aria-label="Навигация">
      {SIDE.slice(0, 2).map(item)}
      <button
        type="button"
        className="tabbar__create"
        aria-label="Создать"
        aria-current={active === 'create' ? 'page' : undefined}
        onClick={() => go('create')}
      >
        <Sparkle size={26} double />
      </button>
      {SIDE.slice(2).map(item)}
    </nav>
  );
}
